export default __webpack_public_path__ + "static/media/jsr-bg.6da45278.png";